/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Title_CreateInputs */



/**
* | output |
* | --- |
* | "Import CSV as a new table" |
*
* @param {Datasets_Import_Csv_Title_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_title_create = /** @type {((inputs?: Datasets_Import_Csv_Title_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Title_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV als neue Tabelle importieren")
	return /** @type {LocalizedString} */ ("Import CSV as a new table")
});